module.exports = __webpack_public_path__ + "static/media/location-pin.00691889.svg";